import { LockRounded } from "@mui/icons-material";
import {
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import AcxMainTextField from "components/UI/AcxMainTextField";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../../Stores/LLMClassifierBuilderStore";

const bodyRowHeight = "48px";

export const RubricSection = observer(() => {
    const store = useStore(LLMClassifierBuilderStore);
    const question = store.dataLabelingQuestion;
    const hasRubric = !!question && store.dataStepRubric.length > 0;

    if (!hasRubric)
        return (
            <TitledSection
                title={
                    <Stack
                        direction="row"
                        alignItems="center"
                        columnGap={1}
                        color="text.disabled"
                    >
                        Rubric
                        <LockRounded fontSize="small" />
                    </Stack>
                }
            >
                <Typography color="text.secondary">
                    Choose a data labeling module and question above. Its valid
                    results fill in here.
                </Typography>
            </TitledSection>
        );

    return (
        <TitledSection
            title="Rubric"
            subtitle="Describe when each result applies."
        >
            <RubricTable />
        </TitledSection>
    );
});

const RubricTable = observer(() => {
    const store = useStore(LLMClassifierBuilderStore);

    return (
        <TableContainer
            sx={(theme) => ({
                border: `1px solid ${theme.palette.lightgrayBorder.main}`,
                borderRadius: "8px",
            })}
        >
            <Table size="small">
                <TableHead
                    sx={(theme) => ({
                        backgroundColor: theme.palette.lightgray.background,
                        "& .MuiTableCell-root": {
                            color: theme.palette.text.secondary,
                            fontSize: "12px",
                            fontWeight: 600,
                            letterSpacing: "0.05em",
                            textTransform: "uppercase",
                            height: "40px",
                            paddingY: 0,
                        },
                    })}
                >
                    <TableRow>
                        <TableCell width="15%">Result</TableCell>
                        <TableCell>Description</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody
                    sx={{
                        "& tr": { height: bodyRowHeight },
                        "& tr:last-child td": { borderBottom: 0 },
                    }}
                >
                    {store.dataStepRubric.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell sx={{ fontWeight: 600 }}>
                                {item.result}
                            </TableCell>
                            <TableCell>
                                <AcxMainTextField
                                    id={`rubric-definition-${item.id}`}
                                    fullWidth
                                    // Starts one line tall and grows with the text.
                                    multiline
                                    multilinePadding
                                    rowsMin={1}
                                    rowsMax={8}
                                    sx={{ paddingY: 0 }}
                                    value={item.definition}
                                    onChange={(event) =>
                                        store.setDataStepRubricDefinition(
                                            item.id,
                                            event.target.value,
                                        )
                                    }
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
});
